<template>
  <ul id="search-results" class="p-0 list-unstyled result-item">
    <li
      v-for="(item, index) in slicedResults" 
      :key="index"
      class="p-0"
      :class="{'bg-background' : index %2 == 0}"
      ref="sourceItem"      
    >
    <div class="d-md-flex justify-content-between h-100 py-2 py-md-1">
      <div @click="openList(index)" class="w-75 list-item-wrap">
        <b-btn
          variant="link"
          class="bg-transparent shadow-none px-2 h-100"
          >
            <i class="fas fa-bars"></i>
        </b-btn>
        <span class="f-narkis h-100 d-none d-md-inline-block">{{item.list[0][0]}}</span> 
        <small class="text-dark mx-2 d-none d-md-inline-block">{{item.sum}} {{hebrew ? 'תוצאות' : 'Rקדוךאד'}}</small>
        <div class="d-inline-block d-md-none w-75 f-narkis" style="line-height:1.3">
          <span>{{item.list[0][0]}}</span><small class="text-dark mx-2">({{item.sum}})</small>
        </div>  
      </div>
      <a class="px-2 my-md-auto mb-auto all-results-link"
        target="_blank" :href="'https://'+searchTool+'.dicta.org.il/result?text=&quot;'+removeSpecialChars(item.lexPhrase)+'&quot;'">
        <small class="text-center h-100 d-inline-block border border-primary">
          <i class="fas fa-external-link-alt px-1"></i>{{hebrew ? 'לכל התוצאות' : 'All results'}}
        </small>   
      </a>
      </div>       
      <div class="inner-results bg-white  pt-2 px-4 border-top border-bottom border-secondary d-none">              
        <div v-for="(resultItem, i) in item.list" :key="i" class="pb-2 d-flex">
          <div>
            <i aria-hidden="true" class="mr-1  mt-2 fas fa-square border-right border-bottom text-white"></i>
          </div>  
          <div class="flex-grow-1 mr-2" >
            <a 
              target="_blank" 
              class="item-link"
              :href="'https://'+searchTool+'.dicta.org.il/result?text=&quot;'+resultItem[0]+'&quot;'">
              <small><i class="fas fa-external-link-alt"></i> {{resultItem[0]}} ({{resultItem[1]}})</small></a>          
          </div>  
        </div>              
      </div>  
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'ResultList',
    props: [ 'searchResults', 'currentPage','perPage'],
    data() {
      return {
        
      }
    },
    methods: {
      closeList () {
        var elems = document.querySelectorAll(".inner-results");
        [].forEach.call(elems, function(el) {                    
          el.classList.add("d-none");
        }) 
      },       
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth < 640 ) {
          
          return true
        } else {
          return false
        }
      },      
      removeSpecialChars (str) {        
        str = str.replace(/\//g, "")
        str = str.replace(/\[/g, "")
        return str
      },
      prevent (event) {
        event.stopPropagation()
      },     
      openList (index) {
        const selectedList = this.$refs.sourceItem[index].getElementsByClassName('inner-results')[0]
        if(this.isMobile()) {
          let isClosed = selectedList.classList.contains('d-none')
          this.closeList()
          if (isClosed) {
            selectedList.classList.remove('d-none')   
          }
        } else {
          selectedList.classList.toggle('d-none') 
        }
      }
    },
    computed: {
      hebrew () {
        return this.$settings.hebrew
      },
      slicedResults () {
        return this.isMobile() ? this.searchResults : this.searchResults.slice(10*(this.currentPage-1),10*(this.currentPage))
      },
      searchTool () {
        return this.$store.state.mode === 'tanach' ? 'search' : 'talmudsearch'
      }
    },
    watch: {
      currentPage () {
        this.closeList()
      }
    }
  }  
</script>
<style scoped lang="scss">
  .fa-external-link-alt {
    font-size: 11px;
    position: relative;
    top: -1px;       
  }
  .all-results-link {
    @media (max-width: 991px)  {
      vertical-align: top;
      position: absolute;
      left: 15px
    }
    small {
      border-radius: 4px;
      width: 110px;
      @media (max-width: 991px)  {        
        margin-top: 2px;
      }
      background: white;
      transition: all .4s ease;     
    }
    &:hover {
      color: #007ee5;
      small {
        background: #d6ecff;
      }  
    }
  }
  .item-link {
    &:hover {
      color: #007ee5;
    }
  }  
  .f-narkis {font-size: 20px;}
  .fa-bars {
    &:hover {
      color: var(--primary);     
    }
    @media (max-width: 991px)  {
      position: relative;
      top: 1px;
    }    
  }
  .fa-square {font-size: 11px;vertical-align: top;}

  li {      
    //height: 41px;
    overflow: hidden;
    //transition:max-height 0.9s ease-out;
    @media (max-width: 991px)  {
      .list-item-wrap {
        width: 60%!important;
        display: inline-block;
        button {
          vertical-align: top;
          margin-top: -2px;
        }
      }
    }
    cursor: pointer;
    .inner-results {
      cursor: auto;
    }
    &.h-auto {
      max-height: 100%;
    }
  }    
</style>